<div class="out-app-container">
  <router-outlet></router-outlet>
</div>
